import { render, staticRenderFns } from "./soDialog.vue?vue&type=template&id=3c2f7cb1&lang=pug"
import script from "./soDialog.vue?vue&type=script&lang=js"
export * from "./soDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports